<div class="card border-0 mb-4">
  <div class="card-header pt-3" *ngIf="!hideCollapseIcon">
    <h2
      id="coachee-list-title"
      class="card-title float-start"
      (click)="triggerCollapse()">
      Smart Feedback
      <i class="bi bi-caret-{{ isCollapsed ? 'up' : 'down' }}-fill"></i>
    </h2>
    <div class="card-tools float-end">
      <a
        routerLink="/dashboard/smart-feedback"
        ngbTooltip="See all smart feedback"
        class="text-primary">
        See All
        <i class="ps-1 bi bi-box-arrow-up-right"></i>
      </a>
    </div>
  </div>
  <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <div
      class="card-body p-0 overflow-auto"
      tabindex="0"
      role="group"
      aria-labelledby="smart-feedback-title">
      <div class="card-padding pt-0">
        <p>
          Choose a skill, upload an artifact or type some context, and get
          instant feedback!
        </p>

        <ng-container *ngIf="!smartFeedback">
          <label class="visually-hidden" [attr.for]="labelId"
            >Competency Select</label
          >
          <ng-select
            [labelForId]="labelId"
            (change)="competencySelected(); selectComp.blur()"
            [items]="competencyList | async"
            multiple="false"
            bindLabel="title"
            [clearable]="true"
            typeToSearchText="Please enter 2 or more characters"
            [typeahead]="searchInput$"
            [loading]="searchLoading"
            [(ngModel)]="selectedCompetency"
            [placeholder]="'Choose a Competency'"
            hideSelected="false"
            [groupBy]="'rubric_name'"
            #selectComp>
          </ng-select>
        </ng-container>

        <ng-container *ngIf="selectedCompetency && smartFeedback">
          <div class="fw-800 mt-3 mb-2">{{ selectedCompetency.title }}</div>
          <app-safehtml [html]="selectedCompetency.content" />
        </ng-container>

        <ng-container *ngIf="artifact">
          <div class="fw-800 mt-4">Artifact</div>
          <app-file-list
            *ngIf="attachments.length > 0"
            [skipApiCallOnDelete]="true"
            [fileList]="attachments"
            [hideDeleteButton]="submittingData || smartFeedback ? true : false"
            [hideDownloadButton]="true"
            (deletedFile)="deleteAttachment($event)" />
        </ng-container>

        <div class="mt-3">
          <app-file-upload
            #uploadComponent
            *ngIf="!artifact"
            [disabled]="attachments.length > 0"
            [style]="uploadStyle"
            (outputFiles)="updateAttachments($event)"
            [outputRaw]="true"
            (outputRawFiles)="updateArtifact($event)" />
        </div>

        <div class="mt-3">
          <div class="fw-800">
            Additional Context
            <div class="fw-400 fs-13 pb-2" *ngIf="!smartFeedback">
              Is there anything else you want to share about this artifact? This
              is optional.
            </div>
          </div>
          <textarea
            *ngIf="!smartFeedback"
            class="form-control"
            aria-label="Narrative"
            [(ngModel)]="narrative"
            (ngModelChange)="checkSubmissonStatus()"></textarea>
          <app-safehtml
            *ngIf="smartFeedback"
            [html]="narrative ? narrative : ''" />
        </div>
      </div>
      <ng-container *ngIf="loadingMessage">
        <div class="loading-message" @deelaayfadeInOut>
          <app-safehtml [html]="loadingMessage"></app-safehtml>
        </div>
      </ng-container>
      <div *ngIf="!smartFeedback" class="card-padding pt-0">
        <div class="d-flex justify-content-end">
          <app-smart-feedback-button
            [isDisabled]="!selectedCompetency || (!artifact && !narrative)"
            [loading]="submittingData"
            [ready]="readyToSubmit"
            [tooltipMessage]="
              'Please select a competency and upload an artifact or type a narrative'
            "
            (buttonClicked)="getSmartFeedback()" />
        </div>
      </div>

      <ng-container *ngIf="errorMessage">
        <div class="p-3">
          <div class="alert alert-danger">
            {{ errorMessage }}
          </div>
        </div>
      </ng-container>

      <div *ngIf="smartFeedback">
        <div class="feedback-header">
          <img src="/assets/stars-pink.svg" class="me-2" alt="Ai Stars" />Smart
          Feedback
        </div>

        <div class="card-padding">
          <ng-container
            *ngIf="smartFeedback.error && smartFeedback.error.length > 0">
            <div class="fw-800 color-danger">Error</div>
            <markdown>{{ smartFeedback.error }}</markdown>
          </ng-container>

          <ng-container
            *ngIf="
              smartFeedback.strengths && smartFeedback.strengths.length > 0
            ">
            <div style="color: #430089" class="fw-800">Strengths</div>
            <markdown>{{ smartFeedback.strengths }}</markdown>
          </ng-container>

          <ng-container
            *ngIf="
              smartFeedback.suggestions && smartFeedback.suggestions.length > 0
            ">
            <div class="fw-800 color-level-3">Suggestions</div>
            <markdown>{{ smartFeedback.suggestions }}</markdown>
          </ng-container>

          <ng-container
            *ngIf="
              smartFeedback.improvements &&
              smartFeedback.improvements.length > 0
            ">
            <div class="fw-800 color-level-1">Next Steps</div>
            <markdown>{{ smartFeedback.improvements }}</markdown>
          </ng-container>

          <ng-container
            *ngIf="smartFeedback.examples && smartFeedback.examples.length > 0">
            <div class="fw-800 color-level-2">Examples</div>
            <markdown>{{ smartFeedback.examples }}</markdown>
          </ng-container>

          <div
            *ngIf="smartFeedbackId"
            class="user-feedback py-2 d-flex justify-content-center align-items-center">
            <button
              class="btn-reset"
              (click)="copySmartFeedback()"
              ngbTooltip="Copy">
              <ng-container *ngIf="!copiedStatus; else checkIcon"
                ><i class="bi bi-copy"></i
              ></ng-container>
              <ng-template #checkIcon>
                <i class="bi bi-check2"></i>
              </ng-template>
            </button>
            <ng-container *ngIf="!userFeedbackSubmitted; else usersubmitted">
              <button
                class="btn-reset"
                (click)="submitUserFeedback('thumbs_up')"
                ngbTooltip="Good Response">
                <i class="bi bi-hand-thumbs-up"></i>
              </button>

              <button
                class="btn-reset"
                (click)="submitUserFeedback('thumbs_down')"
                ngbTooltip="Bad Response">
                <i class="bi bi-hand-thumbs-down"></i>
              </button>
            </ng-container>
            <ng-template #usersubmitted>
              <ng-container *ngIf="userFeedback === 'thumbs_up'; else upbutton">
                <div class="icon-padding">
                  <i class="bi bi-hand-thumbs-up-fill"></i>
                </div>
              </ng-container>
              <ng-template #upbutton>
                <button
                  class="btn-reset"
                  (click)="submitUserFeedback('thumbs_up')"
                  ngbTooltip="Good Response">
                  <i class="bi bi-hand-thumbs-up"></i>
                </button>
              </ng-template>

              <ng-container
                *ngIf="userFeedback === 'thumbs_down'; else downbutton">
                <div class="icon-padding">
                  <i class="bi bi-hand-thumbs-down-fill"></i>
                </div>
              </ng-container>
              <ng-template #downbutton>
                <button
                  class="btn-reset"
                  (click)="submitUserFeedback('thumbs_down')"
                  ngbTooltip="Bad Response">
                  <i class="bi bi-hand-thumbs-down"></i>
                </button>
              </ng-template>
            </ng-template>
          </div>

          <hr />
          <div class="d-flex justify-content-end">
            <button class="btn btn-text" (click)="resetCard()">
              Get more feedback <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
